<template>
  <div style="height: 100%">
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">监控权限</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-form-item label="设备名称" prop="DeviceName">
            <el-input
              v-model="DeviceName"
              placeholder="请输入设备名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="区域">
            <el-select v-model="RegionId" placeholder="请选择">
              <el-option key="" label="全部" value="null"></el-option>
              <el-option
                v-for="item in RegionData"
                :key="item.RegionId"
                :label="item.RegionName"
                :value="item.RegionId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否在线">
            <el-select v-model="IsOnline" placeholder="请选择">
              <el-option key="" label="全部" value="null"></el-option>
              <el-option key="" label="在线" value="true"></el-option>
              <el-option key="" label="离线" value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="设备类型">
            <el-select v-model="DeviceType" placeholder="请选择">
              <el-option key="" label="全部" value="null"></el-option>
              <el-option
                v-for="item in DeviceTypesArr"
                :key="item.Extend1"
                :label="item.Description"
                :value="item.ItemKey"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="" class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-button-bar">
          <el-button size="mini" @click="onAdd">添 加</el-button>
          <el-button size="mini" @click="onbatchDel">删 除</el-button>
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div
            class="zj-table-container"
            v-loading="syncing"
            :element-loading-text="syncingText"
          >
            <el-table
              v-loading="searching"
              element-loading-text="加载中..."
              :data="tableData"
              ref="multipleTable"
              @selection-change="selectionChange"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column
                prop="RoleName"
                label="系统角色"
              ></el-table-column>
              <el-table-column
                prop="DeviceName"
                label="设备名称"
              ></el-table-column>
              <el-table-column prop="RegionName" label="区域">
              </el-table-column>
              <el-table-column
                prop="DeviceType"
                label="设备类型"
                :formatter="getDevicetypeShow"
              >
              </el-table-column>

              <el-table-column prop="IsOnline" label="状态" width="140">
                <template slot-scope="scope">
                  <span v-if="scope.row.IsOnline == false" style="color: red"
                    >离线</span
                  >
                  <span v-if="scope.row.IsOnline == true">在线</span>
                </template>
              </el-table-column>
              <!-- fixed="right"  -->
              <el-table-column label="操作" width="160">
                <template slot-scope="scope">
                  <el-button
                    @click="handleClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                    >查看</el-button
                  >
                  <el-button
                    @click="deleteClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>
<script>
import MyApis from "../../../apis";
import waitAll from "../../../../../../utils/src/waitAll";

export default {
  name: "MonitorPermissionList",
  controller: "UI",
  action: "MonitorPermissionList",
  data() {
    return {
      searching: false, // 搜索中...
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      RegionData: [],
      EquipmentType: "Monitor", //设备类型
      DeviceId: null,
      DeviceName: null, //设备名称
      RegionId: null, //地区ID
      area: "",
      IsOnline: null, //在线是否
      DeviceType: null,
      DeviceTypesArr: [], //设备类型的数组值
      RoleId: "",
      RoleName: "",
      data: [],
      TotalNum: 0,
    };
  },
  created() {
    this.getType();
    this.basedataRegion();
  },
  mounted() {
    this.theme.sidemenu.visiable = false;
    this.search();
    // this.logInfo.ActionName = "监控设备查询";
    // this.logInfo.LogMessage = "监控设备查询";
    // this.logInfo.ModuleName = "视频监控";
    // this.logInfo.PageName = "监控设备管理列表";
    // this.addOperationLog();
  },
  methods: {
    getDevicetypeShow(row, column) {
      let that = this;
      let data = row[column.property];
      if (data) {
        let arr = that.DeviceTypesArr;
        let result = "";
        arr.forEach((item) => {
          if (item.ItemKey == data) {
            result = item.Description;
          }
        });
        return result;
      }
    },
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    // 表格的选中 可以获得当前选中的数据
    selectionChange(val) {
      // 将选中的数据存储起来
      this.selectData = val;
    },
    refreshRoleDevice(data) {
      this.RoleId = data.id;
      this.RoleName = data.label;
      this.search();
    },
    search() {
      this.searching = true;
      let online = null;
      if (this.IsOnline == "true") {
        online = true;
      } else if (this.IsOnline == "false") {
        online = false;
      }
      let lookRegionId = this.RegionId;
      if (this.RegionId == "null") {
        lookRegionId = null;
      }
      let dType = this.DeviceType;
      if (this.DeviceType == "null") {
        dType = null;
      }
      let searchInfo = {
        RoleId: this.RoleId,
        EquipmentType: this.EquipmentType, //设备类型
        DeviceId: this.DeviceId,
        DeviceName: this.DeviceName, //设备名称
        DeviceType: dType,
        DeviceTypes: [],
        RegionId: lookRegionId, //地区ID
        IsOnline: online, //在线是否
        ScenicId: null, //景区ID
        PageSize: 0,
        PageIndex: this.currentPage,
      };
      new MyApis.MonitorPermissionApi()
        .GetPageContentByConditions(searchInfo)
        .then((r) => {
          //console.log("1");
          this.searching = false;
          r = r.data.Data;
          this.data = r.PageContents;
          this.searchPage();
          // this.total = r.BaseSearch.TotalCount;
          // this.TotalNum = this.total;
        })
        .catch((e) => {
          console.log(e);
          this.searching = false;
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    searchPage() {
      this.searching = true;
      let online = null;
      if (this.IsOnline == "true") {
        online = true;
      } else if (this.IsOnline == "false") {
        online = false;
      }
      let lookRegionId = this.RegionId;
      if (this.RegionId == "null") {
        lookRegionId = null;
      }
      let dType = this.DeviceType;
      if (this.DeviceType == "null") {
        dType = null;
      }

      //  es6过滤得到满足搜索条件的展示数据list
      let list = this.data;
      if (this.DeviceName != null) {
        list = this.data.filter((item, index) =>
          item.DeviceName.includes(this.DeviceName)
        );
      }
      if (online != null) {
        list = list.filter((item, index) => item.IsOnline==online);
      }
      if (lookRegionId != null) {
        list = list.filter((item, index) =>
          item.RegionId.includes(lookRegionId)
        );
      }
      if (dType != null) {
        list = list.filter((item, index) => item.DeviceType.includes(dType));
      }

      //过滤分页
      this.tableData = list.filter(
        (item, index) =>
          index < this.currentPage * this.pageSize &&
          index >= this.pageSize * (this.currentPage - 1)
      );
      //分页的总数据
      this.total = list.length;
      this.searching = false;
    },
    clearsearch() {
      this.EquipmentType = null; //设备类型
      this.DeviceId = null;
      this.DeviceName = null; //设备名称
      this.DeviceType = null;

      this.RegionId = null; //地区ID
      this.IsOnline = null; //在线是否
      this.search();
    },
    basedataRegion() {
      let searchInfo = {
        EquipmentType: "Monitor",
        Longitude: 0.0,
        Latitude: 0.0,
      };
      new MyApis.RegionApi()
        .GetRegionInfos(searchInfo)
        .then((r) => {
          this.RegionData = r.data.Data;
          this.localRegions = r.data.Data.map((x) => {
            return x.RegionId;
          });
          this.defaultRegion = r.data.Data.find((x) => {
            if (x.RegionName == "其他" || x.RegionName == "其它") {
              return x;
            }
          });
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.searchPage();
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
    },

    //编辑按钮
    editClick(index, row) {
      this.$router.push({
        path: "/plugin/monitor/UI/monitorInfo",
        query: {
          DeviceId: row.DeviceId,
          type: "edit",
        },
      });
    },
    //查看详细
    handleClick(index, row) {
      console.log(index);
      console.log(row);
      this.$router.push({
        path: "/plugin/monitor/UI/monitorInfo",
        // name: 'mallList',
        query: {
          DeviceId: row.DeviceId,
          type: "look",
        },
      });
    },
    //添加
    onAdd() {
      if (this.RoleId == "" || this.RoleId == null) {
        this.$message({
          type: "info",
          message: "请先选择系统角色",
        });
        return;
      }

      this.$router.push({
        path: "/plugin/monitor/UI/MonitorDeviceList",
        query: {
          type: "add",
          RoleId: this.RoleId,
          RoleName: this.RoleName,
        },
      });
    },
    //批量删除
    onbatchDel() {
      if (
        this.selectData != undefined &&
        this.selectData != null &&
        this.selectData.length > 0
      ) {
        this.$confirm("选中的数据将被永久删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            const selectData = this.selectData;
            const count = selectData.length;
            var arr = [];
            // 清除 所有勾选项
            this.$refs.multipleTable.clearSelection();
            if (count > 0) {
              selectData.forEach((item) => {
                new MyApis.MonitorPermissionApi()
                  .DelItem({ Id: item.MonitorPermissionId })
                  .then((r) => {
                    r = r.data.Data;
                    arr.push(r);
                  })
                  .catch((e) => {
                    console.log(e);
                  });
              });
              waitAll(arr)
                .then((r) => {
                  // resolve(r);
                  if (r) {
                    this.$message({
                      type: "success",
                      message: "删除成功!",
                    });
                    this.logInfo.ActionName = "监控权限设备删除";
                    this.logInfo.LogMessage = "监控权限设备删除";
                    this.logInfo.ModuleName = "视频监控";
                    this.logInfo.PageName = "监控权限设备管理列表";
                    this.addOperationLog();
                    this.search();
                  }
                })
                .catch((e) => {
                  // reject(e);
                  if (e) {
                    this.$message({
                      type: "error",
                      message: "删除失败!",
                    });
                  }
                });
            }
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      } else {
        this.$message({
          type: "info",
          message: "未选中任何行！",
        });
      }
    },
    //行删除
    deleteClick(index, row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          new MyApis.MonitorPermissionApi()
            .DelItem({ Id: row.MonitorPermissionId })
            .then((r) => {
              r = r.data.Data;
              if (r) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                this.logInfo.ActionName = "监控权限设备删除";
                this.logInfo.LogMessage = "监控权限设备删除";
                this.logInfo.ModuleName = "视频监控";
                this.logInfo.PageName = "监控权限设备管理列表";
                this.addOperationLog();
              } else {
                this.$message({
                  type: "error",
                  message: "删除失败!",
                });
              }
              this.search();
            })
            .catch((e) => {
              console.log(e);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.searchPage();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.searchPage();
    },
    ConvertTranresourcesType(row, column) {
      let data = row[column.property];
      if (data == null) {
        return null;
      }
      let levelstr = this.TranresourcesTypeDic[data];
      return levelstr;
    },
    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    },
    getType() {
      let that = this;
      this.config
        .getUValue(":Monitor.DeviceTypes", "")
        .then((d) => {
          console.log(d);
          that.DeviceTypesArr = d.JValue;
        })
        .catch((e) => console.error(e));
    },
  },
  beforeDestroy() {
    this.theme.sidemenu.visiable = true;
  },
};
</script>
